// @need-translate
import {t} from '../../../../common/getTranslations';
import {Maybe, OnIssue} from '../../../../graphql/generated/types';

export function getOverviewPublishPeriodText(
  onIssue: OnIssue,
  publishPeriod?: Maybe<string>
) {
  return onIssue === OnIssue.End
    ? t('common_badge_completed')
    : onIssue === OnIssue.Pause
      ? t('common_content_rest')
      : `${t('contenthome_publish_some_days', {
          values: {
            value: getShortenPublishPeriodText(publishPeriod) || '',
          },
        })}`;
}

/**
 * 기획&디자인 요청으로 요일관련 요일을 컴팩트하게 활용하기 위해 만든 함수(클라에서 처리)
 *
 * 월, 화, 수, 목, 금, 토 일 : 매일 연재
 * 4일 연속 요일이 있는 경우 :
 * - 월, 화, 수, 목 : 월~목 연재
 * - 월, 화, 수, 목, 금 : 월~금 연재
 * - 월, 화, 수, 목, 금, 토 : 월~토 연재
 * - 화, 수, 목, 금 : 화~금 연재
 * - 화, 수, 목, 금, 토: 화~토 연재
 * - 화, 수, 목, 금, 토, 일 : 화~일 연재
 * - 수, 목, 금, 토, 일 : 수~일 연재
 * - 수, 목, 금, 토 : 수~토 연재
 * - 목, 금, 토, 일 : 목~일 연재
 * - 그외 : {요일}, {요일} 콤마로 요일을 붙여서 노출 + 연재
 * 해당없음 : 연재요일 미노출하고 ‘연재’만 노출
 * 연재상태값이 ‘완결’인 경우 ‘완결’ 노출
 * 연재상태값이 ‘휴재’인 경우 ‘휴재’ 노출
 */
function getShortenPublishPeriodText(publishPeriod?: Maybe<string>) {
  if (!publishPeriod) {
    return '';
  }

  const checkPublishPeriod = publishPeriod.replace(/ /g, '');
  // 참고: https://kakaopagecorp.slack.com/archives/C040YR56D/p1742870854740379?thread_ts=1737440137.349739&cid=C040YR56D
  return (
    {
      '월,화,수,목,금,토,일': t('common_content_everyday'),
      '월,화,수,목': `${t('common_content_mon')}~${t('common_content_thu')}`,
      '월,화,수,목,금': `${t('common_content_mon')}~${t('common_content_fri')}`,
      '월,화,수,목,금,토': `${t('common_content_mon')}~${t('common_content_sat')}`,
      '화,수,목,금': `${t('common_content_tue')}~${t('common_content_fri')}`,
      '화,수,목,금,토': `${t('common_content_tue')}~${t('common_content_sat')}`,
      '화,수,목,금,토,일': `${t('common_content_tue')}~${t('common_content_sun')}`,
      '수,목,금,토,일': `${t('common_content_wed')}~${t('common_content_sun')}`,
      '수,목,금,토': `${t('common_content_wed')}~${t('common_content_sat')}`,
      '목,금,토,일': `${t('common_content_thu')}~${t('common_content_sun')}`,
    }[checkPublishPeriod] || publishPeriod
  );
}
